import { lazyGetReportSections } from "owa-mail-ribbon-sections/lib/sections";

import type { MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";

export const onReportMenuClicked = (keytipTabId: MailRibbonTabId | undefined, props: ReadOnlyRibbonControlDefProps): void => {
    lazyGetReportSections.import().then(getReportSections => {
        setMenuDefinition("ReportMenuDefinitionStore", props.projectionTabId, () => {
            return {
                sections: getReportSections(keytipTabId, props),
            };
        });
    });
};
